import styled, { css } from 'styled-components';

import { defaultThemeProp, Flex, Image, StyledCard, Text } from '@pega/cosmos-react-core';
import { ellipsisOverflow, lineClamp } from '@pega/cosmos-react-core/lib/styles/mixins';

export const StyledOpenGraphTitle = styled(Text)(
  ({ theme }) => css`
    font-weight: ${theme.components.text.h4['font-weight']};
    flex-grow: 1;
    ${ellipsisOverflow}
  `
);

StyledOpenGraphTitle.defaultProps = defaultThemeProp;

export const StyledOpenGraphDescription = styled(Text)`
  ${lineClamp(2)}
`;

export const StyledOpenGraphText = styled(Text)`
  ${ellipsisOverflow}
`;

export const StyledOpenGraphAnchor = styled.a<{ compact?: boolean; $loading: boolean }>(
  ({ compact, $loading, theme }) => css`
    width: ${compact ? '50%' : 'auto'};
    display: ${$loading ? 'none' : 'block'};
    padding-inline-end: calc(${theme.base.spacing} / 4);
    text-decoration: inherit;
    color: inherit;
    cursor: pointer;

    & > ${StyledCard} {
      border-radius: var(--border-radius, ${theme.components.card['border-radius']});
    }

    :focus > ${StyledCard} {
      box-shadow: ${theme.base.shadow.focus};
    }

    :focus-visible {
      outline: none;
    }
  `
);

StyledOpenGraphAnchor.defaultProps = defaultThemeProp;

export const StyledOpenGraphCardContent = styled(Flex)(
  ({ theme }) => css`
    border: 0.0625rem solid ${theme.base.palette['border-line']};
    border-radius: inherit;
    overflow: hidden;

    &:has(img) {
      min-height: 5.75rem;
    }
  `
);

StyledOpenGraphCardContent.defaultProps = defaultThemeProp;

export const StyledOpenGraphImageContainer = styled(Flex)<{ imageHref?: string }>(
  ({ imageHref, theme }) => css`
    min-height: inherit;
    height: auto;
    min-width: 30%;
    max-width: 30%;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    position: relative;
    border-inline-end: solid 0.0625rem ${theme.base.palette['border-line']};

    &::after {
      content: '';
      z-index: 1;
      position: absolute;
      inset: 0;
      opacity: 0.33;
      background: ${imageHref ? `url(${imageHref})` : theme.base.palette['app-background']};
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      filter: blur(1.2rem);
      scale: 1.5;
    }
  `
);

StyledOpenGraphImageContainer.defaultProps = defaultThemeProp;

export const StyledOpenGraphImage = styled(Image)(
  ({ theme }) => css`
    /* stylelint-disable-next-line unit-allowed-list */
    max-height: calc(4lh + ${theme.base.spacing} * 3);
    object-fit: contain;
    z-index: 2;
  `
);

StyledOpenGraphImage.defaultProps = defaultThemeProp;
